// Onboarding tour steps configuration.
// Each step is shown in order. To reorder, move the object.
// To add a step, insert a new object anywhere in the array.
//
// Fields:
//   title     {string}  Tooltip heading
//   text      {string}  Tooltip body
//   target    {string|null}  CSS selector for the element to highlight.
//                            null = centered overlay (good for intro/outro steps)
//   placement {string}  Where to render the tooltip relative to the target:
//                       'top' | 'bottom' | 'left' | 'right'
//   mobile    {object}  Optional overrides used when the primary target is
//                       hidden or missing (e.g. on smaller screens).
//                       Supports: { target, placement }
//                       The component tries the primary target first; if its
//                       rect is zero it automatically falls back to mobile.target.

export default [
  {
    title: 'Welcome to Market Price Simulator!',
    text: 'This is a simulated financial market where traders place buy and sell orders that match each other automatically. Let\'s take a quick tour.',
    target: null,
    placement: 'center'
  },
  {
    title: 'Place an Order',
    text: 'Each trader card has a Trade tab. Enter a price and quantity, then click Buy or Sell to submit an order to the market.',
    target: '.trader-card',
    placement: 'top',
    mobile: { target: '.trader-card-mobile', placement: 'bottom' }
  },
  {
    title: 'Set Your Price',
    text: 'Enter a custom price here, or leave it empty to use the current market price. Adjust the quantity in the field below.',
    target: '.ob-price-input',
    placement: 'bottom',
    mobile: { target: '.ob-price-input-mobile', placement: 'top' }
  },
  {
    title: 'Pending Orders',
    text: 'Orders that haven\'t found a matching counterparty yet wait here. Click the X button next to any order to cancel it.',
    target: '.ob-pending-tab',
    placement: 'bottom',
    mobile: { target: '.ob-pending-tab-mobile', placement: 'bottom' }
  },
  {
    title: 'Order Book',
    text: 'All pending sell orders (asks) are shown in red and buy orders (bids) in green, aggregated by price level.',
    target: '#order-book',
    placement: 'right',
    mobile: { target: '#mobile-tab-orderbook', placement: 'bottom' }
  },
  {
    title: 'Trade History',
    text: 'When a buy and sell order match at the same price, the trade executes immediately and appears here.',
    target: '#orders-history',
    placement: 'left',
    mobile: { target: '#mobile-tab-history', placement: 'bottom' }
  },
  {
    title: 'Price Chart',
    text: 'Executed trade prices are plotted over time. Watch for trends as trading activity picks up.',
    target: '#price-chart',
    placement: 'bottom',
    mobile: { target: '#mobile-tab-chart', placement: 'bottom' }
  },
  {
    title: 'Add a New Trader',
    text: 'Want more market participants? Click here to create a new trader with a custom name and starting funds.',
    target: '#nav-add-trader',
    placement: 'bottom',
    mobile: { target: 'button.navbar-toggler', placement: 'bottom' }
  },
  {
    title: 'Save Your Session',
    text: 'Use Save / Load to bookmark your simulation state at any time and resume exactly where you left off.',
    target: '#nav-save',
    placement: 'bottom',
    mobile: { target: 'button.navbar-toggler', placement: 'bottom' }
  }
]
